





















































import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation, Action} from 'vuex-class'
import {Room, RoomType, Lead, Location} from '@/store/types'
import AppHeader from '@/components/common/AppHeader.vue'
import InventoryRoom from '@/components/inventory/InventoryRoom.vue'
import InventoryEditRoomOverlay from '@/components/inventory/InventoryEditRoomOverlay.vue'
import InventoryCustomRoomOverlay from '@/components/inventory/InventoryCustomRoomOverlay.vue'
import FontAwesome from '@/classes/FontAwesome'

@Component({
  components: {
    AppHeader,
    InventoryRoom,
    InventoryEditRoomOverlay,
    InventoryCustomRoomOverlay,
  },
})
export default class RoomsList extends Vue {
  @Getter('lead') public lead!: Lead
  @Getter('location') public location!: Location
  @Getter('rooms') public rooms!: Room[]
  @Getter('roomTypes') public roomTypes!: RoomType[]
  @Getter('roomTypesWithoutCustom') public roomTypesWithoutCustom!: RoomType[]
  @Getter('showInventoryEditRoomOverlay') public showInventoryEditRoomOverlay!: boolean
  @Getter('showInventoryCustomRoomOverlay') public showInventoryCustomRoomOverlay!: boolean
  @Mutation('setActiveRoomId') public setActiveRoomId!: any
  @Mutation('setInventoryCustomRoomOverlay') public setInventoryCustomRoomOverlay!: any
  @Mutation('setActiveGroups') public setActiveGroups!: any
  @Mutation('setLoader') public setLoader!: any
  @Action('addRoom') public addRoom!: any

  public FontAwesome = FontAwesome

  public roomName(name: string) {
      return name.includes('Master') ? name.replace('Master', 'Mast.') : name
  }

  public createUniqueName(room: RoomType): any {
    return `${room.name} ${this.existingRoomCount(room) + 1}`
  }

  public existingRoomCount(room: RoomType) {
    return this.rooms.filter((r) => r.room_id === room.id).length
  }

  public add(room: RoomType) {
    this.setLoader(true)
    const data: any = {
      lead_id: this.lead.id,
      lead_location_id: this.location.id,
      room_id: room.id,
    }
    if (!!this.existingRoomCount(room)) {
      data.name = this.createUniqueName(room)
    }

    this.addRoom(data).then((room: Room) => {
      this.setActiveGroups(room.room_id)
      this.setActiveRoomId(room.id)
      this.setLoader(false)
      this.$router.push({ path: `rooms/${room.id}/items`})
    })
  }

  public back() {
    this.$router.back()
  }

}
